import { AddSpeakerModal } from "./AddSpeakerModal";

export default AddSpeakerModal;
